import React, { useState } from "react";
import { Link } from "gatsby";
import { getCart } from "../utils/cart";
import { graphql } from 'gatsby';
import styled from "styled-components";
import SEO from '../components/Seo';
import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard/ProductCard";
import Header from "../components/Header/Header";

const SHIPPING_COST = 9.77;

// Inner Components
const Container = styled.div`
  width: 100%;
  margin: 0px auto;
  max-width: 1200px;
  padding: 0 40px;
  /* @media (max-width: 1100px) {
    width: 75%;
  } */
  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`;

const Separator = styled.div`
  width: 100%;
  border: 1px solid #C1A886;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  @media (max-width: 768px) {
    width: calc(100% - 20px);
    margin: 10px auto;
  }
`;

const Title = styled.h3`
  color: #B6936C;
`;

const ConfirmButton = styled.button`
  background-color: ${props => props.color ? props.color : '#77C686'};
  border: 1px solid ${props => props.color ? props.color : '#77C686'};
  border-radius: 3px;
  padding: 20px 40px;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  margin-bottom: 40px;
`;

const TextContainer = styled.div`
  margin: 20px 0px;
  @media (max-width: 768px) {
    margin: 15px 15px;
    font-size: 14px;
  }
`;

const HideMobile = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

const SubtotalP = styled.p`
  margin: 0px;
  margin-left: 190px;
  @media (max-width: 768px) {
    margin-left: 40px;
    font-size: 22px
  }
`;

const ShippingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 190px;
  @media (max-width: 768px) {
    margin-left: 40px;
    font-size: 22px
  }
`;

const TotalContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 15px 0px;
  align-items: center;
  background-color: #B6936C;
  border: 1px solid #B6936C;
  border-radius: 3px;
  color: white;
  @media (max-width: 768px) {
    border-radius: 0px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.center ? 'center' : 'flex-end'};
  margin: 40px 0px;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

// const EmptyContainer = styled.div`
//   height: 50%;
//   padding: 10% 20px;
//   @media (max-width: 768px) {
//     padding: 20% 20px;
//   }
// `;

const EmptyCartContainer = () => {
  return (
    <div key={"123"} style={{ height: '50%', padding: '10% 20px' }}>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", margin: "40px 0px" }}>
        <Link to={`/#store`}>
          <ConfirmButton color="#B6936C" key={"12345"}>"Voltar à Loja"</ConfirmButton>
        </Link>
      </div>
    </div>
  )
}

const ResumePage = ({
  data: {
    allStrapiProgram: { nodes: program }
  }
}) => {

  const { headerImage } = program[0];
  const [value, setValue] = useState(0);

  const cart = getCart();
  let products = [], subtotal = 0, total = 0;

  if (cart) {
    products = cart.products;
    products.forEach(prod => {

      // Check if exist a discount
      let finalPrice = 0.00;

      if (prod.discount && prod.discount.active && prod.discount.price) {
        finalPrice = prod.discount.price;
      } else {
        finalPrice = prod.price;
      }

      switch (prod.pack) {
        case 'pack1':
          subtotal += finalPrice;
          break;
        case 'pack2':
          subtotal += finalPrice * 2;
          break;
        case 'pack3':
          subtotal += finalPrice * 3;
          break;
        default:
          break;
      }
    });
    total = SHIPPING_COST + subtotal;
  }

  return (
    <Layout key={"1234567"}>
      <SEO
        key={"12345678"}
        pageTitle={'Resumo da encomenda'}
        description={'Página oficial da Feira do Vinho do Dão - programa, imagens e noticias ao momento'}
      />
      <Header
        key={"123456789"}
        title="Encomenda"
        subtitle="Resumo da"
        image={headerImage}
        margin="20%"
      />
      <Container key={"1234567891"}>
        <TextContainer key={"12345678912"}>
          {!(products.length === 0) ?
            <p style={{ fontSize: '18px', color: '#707070' }}>
              Resumo da sua encomenda. Confirme os valores e de seguida clique em 'Confirmar' para avançar.
            </p>
            :
            <p style={{ fontSize: '18px', color: '#707070' }}>Parece que o seu carrinho está vazio!</p>
          }
        </TextContainer>
        <div key={"12345678913"}>
          {products.length !== 0 &&
            <HideMobile key={"12345678914"}>
              <Title>No seu carrinho:</Title>
              <Separator />
            </HideMobile>
          }
        </div>
        <div key={"1234567892"}>
          {products.length === 0 && <EmptyCartContainer key={"1234567893"} />}
          {products.length !== 0 &&
            <span>
              {products.map(product => {
                return (
                  <div key={product.id}>
                    <ProductCard
                      key={product.id}
                      product={product}
                      pack={product.pack}
                      onPackChange={() => setValue(value + 1)}
                      resumeView
                    />
                    <Separator key={"1234567894"} />
                  </div>
                );
              })}
              <div key={"123456786"} style={{ display: 'flex', flexDirection: 'column', color: '#B6936C' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  margin: '25px 0px',
                  alignItems: 'center',
                }}>
                  <SubtotalP key={"123456781234"}>Sub-total a pagar</SubtotalP>
                  <b key={"121267893"} style={{ margin: '0px', marginRight: '40px' }}><p style={{ margin: '0px' }}>€{subtotal.toFixed(2)}</p></b>
                </div>
                <Separator key={"1234567893635"} />
                <div key={"12354525842667893"} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  margin: '25px 0px',
                  alignItems: 'center',
                }}>
                  <ShippingContainer key={"123211fe25258as93"}>
                    <p style={{ margin: '0px' }}>Custo de Envio</p>
                    <p style={{ margin: '0px', fontSize: '12px' }}>Apenas para território nacional</p>
                  </ShippingContainer>
                  <p style={{ margin: '0 40px 0 0' }}>€{SHIPPING_COST.toFixed(2)}</p>
                </div>
                <TotalContainer key={"123545258as93"}>
                  <div key={"123222225258as93"} style={{ display: 'flex', flexDirection: 'column', marginRight: '60px' }}>
                    <b><p style={{ margin: '0px' }}>TOTAL A PAGAR</p></b>
                    <p style={{ margin: '0px', fontSize: '12px', textAlign: 'right' }}>IVA incluído</p>
                  </div>
                  <b><p style={{ margin: '0 40px 0 0' }}>€{total.toFixed(2)}</p></b>
                </TotalContainer>
              </div>
              <ButtonContainer key={"as123"}>
                <Link to="/details">
                  <ConfirmButton key={"1235as"}>Encomendar</ConfirmButton>
                </Link>
              </ButtonContainer>
            </span>}
        </div>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  {
    allStrapiProgram {
      nodes {
        headerImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;

export default ResumePage;
